/**
 * 兑换码格式与校验位（与 supabase/functions/_shared/redemption_code.ts 同一份算法）。
 * 用途：输错一位时在本地直接拦下，不发请求、不消耗后端的限流次数。
 * ⚠️ 改动必须与后端、Android `RedemptionCode.kt` 三处同步。
 */

const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
const CODE_LENGTH = 16;
const OPTIONAL_PREFIX = "BMB";

function checksumChar(body: string): string {
  let sum = 0;
  for (let i = 0; i < body.length; i++) {
    sum += ALPHABET.indexOf(body[i]) * (2 * i + 1);
  }
  return ALPHABET[sum % 32];
}

/** 规范化并校验；不合法返回 null，合法返回 16 位规范码。 */
export function normalizeCode(input: string): string | null {
  let s = input.toUpperCase().replace(/[^0-9A-Z]/g, "");
  s = s.replace(/O/g, "0").replace(/[IL]/g, "1");
  if (s.length === CODE_LENGTH + OPTIONAL_PREFIX.length && s.startsWith(OPTIONAL_PREFIX)) {
    s = s.slice(OPTIONAL_PREFIX.length);
  }
  if (s.length !== CODE_LENGTH) return null;
  for (const ch of s) if (!ALPHABET.includes(ch)) return null;
  if (checksumChar(s.slice(0, CODE_LENGTH - 1)) !== s[CODE_LENGTH - 1]) return null;
  return s;
}

/** 输入框里边输入边整理成 `XXXX-XXXX-XXXX-XXXX`（不做校验，只做格式化）。 */
export function formatForInput(raw: string): string {
  let s = raw.toUpperCase().replace(/[^0-9A-Z]/g, "");
  if (s.startsWith(OPTIONAL_PREFIX) && s.length > CODE_LENGTH) s = s.slice(OPTIONAL_PREFIX.length);
  s = s.slice(0, CODE_LENGTH);
  return s.match(/.{1,4}/g)?.join("-") ?? "";
}

export function formatCode(canonical: string): string {
  return canonical.match(/.{1,4}/g)!.join("-");
}
